/* Woven Wood – Case Studies: listing filters + detail slider */
(function () {
  'use strict';

  /* ---------------- Listing filters ---------------- */
  function initListing(root) {
    if (root.dataset.csReady) return;
    root.dataset.csReady = 'true';

    var grid = root.querySelector('[data-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cs-card]'));
    var pills = root.querySelectorAll('[data-filter]');
    var sortSelect = root.querySelector('[data-sort]');
    var countEl = root.querySelector('[data-count]');
    var emptyEl = root.querySelector('[data-empty]');
    var loadMoreBtn = root.querySelector('[data-load-more]');
    var perPage = parseInt(root.dataset.perPage, 10) || 9;

    // Multi-select: each group holds an array of selected values ([] = All)
    var state = { product: [], client: [], sort: 'newest', visible: perPage };

    function validValue(group, value) {
      return !!root.querySelector('[data-filter="' + group + '"][data-value="' + CSS.escape(value) + '"]');
    }

    // Read initial state from URL (?product=zinc-planters,lawn-edging&client=residential&sort=oldest)
    var params = new URLSearchParams(window.location.search);
    ['product', 'client'].forEach(function (group) {
      var raw = params.get(group);
      if (!raw) return;
      state[group] = raw.split(',').filter(function (v) {
        return v && v !== 'all' && validValue(group, v);
      });
    });
    if (['newest', 'oldest', 'az'].indexOf(params.get('sort')) !== -1) state.sort = params.get('sort');
    if (sortSelect) sortSelect.value = state.sort;

    // OR within a group, AND between groups
    function matches(card) {
      var products = (card.dataset.products || '').split(' ');
      var clients = (card.dataset.clients || '').split(' ');
      var okProduct = !state.product.length || state.product.some(function (v) { return products.indexOf(v) !== -1; });
      var okClient = !state.client.length || state.client.some(function (v) { return clients.indexOf(v) !== -1; });
      return okProduct && okClient;
    }

    function sortCards(list) {
      return list.slice().sort(function (a, b) {
        if (state.sort === 'az') return a.dataset.title.localeCompare(b.dataset.title);
        var da = parseInt(a.dataset.date, 10) || 0;
        var db = parseInt(b.dataset.date, 10) || 0;
        return state.sort === 'oldest' ? da - db : db - da;
      });
    }

    function updateUrl() {
      var url = new URL(window.location.href);
      ['product', 'client'].forEach(function (group) {
        if (!state[group].length) url.searchParams.delete(group);
        else url.searchParams.set(group, state[group].join(','));
      });
      if (state.sort === 'newest') url.searchParams.delete('sort');
      else url.searchParams.set('sort', state.sort);
      window.history.replaceState({}, '', url.toString());
    }

    function render() {
      var sorted = sortCards(cards);
      sorted.forEach(function (card) { grid.appendChild(card); });

      var matching = sorted.filter(matches);
      sorted.forEach(function (card) { card.hidden = true; });
      matching.slice(0, state.visible).forEach(function (card) { card.hidden = false; });

      var shown = Math.min(state.visible, matching.length);
      if (countEl) countEl.textContent = 'Showing ' + shown + ' of ' + matching.length + ' case studies';
      if (emptyEl) emptyEl.hidden = matching.length !== 0;
      if (loadMoreBtn) loadMoreBtn.hidden = matching.length <= state.visible;

      pills.forEach(function (pill) {
        var group = state[pill.dataset.filter];
        var active = pill.dataset.value === 'all' ? group.length === 0 : group.indexOf(pill.dataset.value) !== -1;
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      updateUrl();
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.dataset.filter;
        var value = pill.dataset.value;
        if (value === 'all') {
          state[group] = [];
        } else {
          var i = state[group].indexOf(value);
          if (i === -1) state[group].push(value);
          else state[group].splice(i, 1);
        }
        state.visible = perPage;
        render();
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        render();
      });
    }

    root.querySelectorAll('[data-clear]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.product = [];
        state.client = [];
        state.sort = 'newest';
        state.visible = perPage;
        if (sortSelect) sortSelect.value = 'newest';
        render();
      });
    });

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var firstNew = state.visible;
        state.visible += perPage;
        render();
        // Move focus to the first newly shown card for keyboard users
        var visibleCards = cards.filter(function (c) { return !c.hidden; });
        var sortedVisible = sortCards(visibleCards);
        var target = sortedVisible[firstNew];
        if (target) {
          var link = target.querySelector('.cs-card__title a');
          if (link) link.focus({ preventScroll: false });
        }
      });
    }

    render();
  }

  /* ---------------- Detail slider (theme Swiper) ---------------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  var swiperLoading = null;
  function loadSwiper(src) {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (swiperLoading) return swiperLoading;
    swiperLoading = new Promise(function (resolve, reject) {
      function inject() {
        if (window.Swiper) return resolve(window.Swiper);
        var script = document.createElement('script');
        script.src = src;
        script.onload = function () { resolve(window.Swiper); };
        script.onerror = reject;
        document.head.appendChild(script);
      }
      // If the theme already includes Swiper, wait briefly for it before loading our copy
      var existing = document.querySelector('script[src*="swiper-bundle"]');
      if (existing) {
        existing.addEventListener('load', function () { if (window.Swiper) resolve(window.Swiper); });
        setTimeout(inject, 1500);
      } else {
        inject();
      }
    });
    return swiperLoading;
  }

  function initSlider(root) {
    if (root.dataset.csReady) return;
    root.dataset.csReady = 'true';

    var mainEl = root.querySelector('[data-main]');
    var thumbsEl = root.querySelector('[data-thumbs]');
    var slides = root.querySelectorAll('.cs-slider__slide');
    if (!mainEl || slides.length < 2) return;

    var counter = root.querySelector('[data-counter]');

    loadSwiper(root.dataset.swiperSrc).then(function (Swiper) {
      if (!Swiper) return;

      var thumbsSwiper = null;
      if (thumbsEl) {
        thumbsSwiper = new Swiper(thumbsEl, {
          slidesPerView: 4,
          spaceBetween: 8,
          watchSlidesProgress: true,
          watchSlidesVisibility: true, // Swiper 6 compatibility
          breakpoints: { 750: { slidesPerView: 6 } }
        });
      }

      function update(swiper) {
        var i = swiper.realIndex;
        if (counter) counter.textContent = 'Image ' + pad(i + 1) + ' / ' + pad(slides.length);
      }

      var main = new Swiper(mainEl, {
        slidesPerView: 1,
        speed: 500,
        navigation: {
          prevEl: root.querySelector('[data-prev]'),
          nextEl: root.querySelector('[data-next]')
        },
        keyboard: { enabled: true, onlyInViewport: true },
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
        on: {
          init: function (swiper) { update(swiper || this); },
          slideChange: function (swiper) { update(swiper || this); }
        }
      });

      root._csSwiper = main;
    }).catch(function () { /* Swiper failed to load: first image stays visible */ });
  }

  function initAll() {
    document.querySelectorAll('[data-cs-listing]').forEach(initListing);
    document.querySelectorAll('[data-cs-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Re-init inside the Shopify theme editor
  document.addEventListener('shopify:section:load', initAll);
})();
